'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_ui_Action(label, to) {
  this.j8 = null;
  this.j9 = null;
  this.j8 = label;
  this.j9 = to;
}
export { $c_Lio_intela_sites_digitalinternship_ui_Action as $c_Lio_intela_sites_digitalinternship_ui_Action };
$p = $c_Lio_intela_sites_digitalinternship_ui_Action.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_ui_Action;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_ui_Action() {
}
export { $h_Lio_intela_sites_digitalinternship_ui_Action as $h_Lio_intela_sites_digitalinternship_ui_Action };
$h_Lio_intela_sites_digitalinternship_ui_Action.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 951882230, true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_ui_Action)) {
    if ((this.j8 === x$0.j8)) {
      var x = this.j9;
      var x$2 = x$0.j9;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "Action";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.j8;
  }
  if ((n === 1)) {
    return this.j9;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_ui_Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bT)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_ui_Action as $isArrayOf_Lio_intela_sites_digitalinternship_ui_Action };
var $d_Lio_intela_sites_digitalinternship_ui_Action = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_ui_Action, "io.intela.sites.digitalinternship.ui.Action", ({
  bT: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_ui_Action as $d_Lio_intela_sites_digitalinternship_ui_Action };
//# sourceMappingURL=io.intela.sites.digitalinternship.ui.-Action.js.map
